import {
  Box,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  useMediaQuery,
  useTheme,
} from '@chakra-ui/react';
import { AnimatePresence, motion } from 'framer-motion';
import PropTypes from 'prop-types';
import React, { useEffect, useState, useRef } from 'react';

import hiddenMavenoid from '../../utils/hiddenMavenoid';

export default function DrawerModal({ children, isOpen, onClose, modalWidth }) {
  const theme = useTheme();
  const modalBodyRef = useRef(null);
  const [isLgScreen] = useMediaQuery(`(min-width: ${theme.breakpoints.lg})`);

  const [isClosing, setIsClosing] = useState(false);

  const handleClose = () => {
    setIsClosing(false);
    onClose();
  };

  const handleDrag = (_, info) => {
    if (info.offset.y > 500) {
      setIsClosing(true);
    }
    if (info.offset.y > 0) {
      handleClose();
    }
  };

  useEffect(() => {
    hiddenMavenoid(isOpen);
  }, [isOpen]);

  return (
    <AnimatePresence>
      <Modal
        isCentered
        isOpen={isOpen}
        onClose={handleClose}
        flexDirection={{ base: 'column', lg: 'row' }}
      >
        <ModalOverlay zIndex={5} />
        {isOpen && (
          <Box
            id="modal_wrapper_box"
            as={motion.div}
            style={{
              position: 'fixed',
              bottom: 0,
              left: 0,
              right: 0,
              top: !isLgScreen && isClosing ? '100%' : 0,
            }}
            zIndex={999}
            initial={!isLgScreen && { y: '100%' }}
            w={{ base: '100vw', lg: 'auto' }}
            animate={
              !isLgScreen &&
              (isClosing
                ? { y: '100%', transition: { duration: 0.5 } }
                : { y: 0, transition: { duration: 0.5 } })
            }
            exit={!isLgScreen && { y: '100%' }}
            drag={!isLgScreen && 'y'}
            onDragEnd={!isLgScreen && handleDrag}
            dragConstraints={!isLgScreen && { top: 0 }}
            dragElastic={!isLgScreen && { top: 0, bottom: 0.3 }}
          >
            <ModalContent
              w={{ base: 'full', lg: modalWidth }}
              maxW={{ base: 'full', lg: modalWidth }}
              borderRadius={['24px 24px 0px 0px', null, 'lg']}
              h={{ base: 'max', lg: 'max' }}
              mb="0"
              mt={{ base: 'auto', lg: 0 }}
            >
              <ModalCloseButton
                borderColor="stroke.base"
                borderRadius="lg"
                borderWidth="1px"
                w="40px"
                h="40px"
                top="6"
                right="6"
                zIndex={1}
                display={['none', null, 'block']}
                bg="white"
              />
              <ModalBody
                pb={['5.5rem', null, '10']}
                px={[4, null, '10']}
                pt={[4, null, '10']}
                ref={modalBodyRef}
              >
                <Box
                  h="6px"
                  w="68px"
                  borderRadius="10px"
                  background="#D9D9D9"
                  pos="absolute"
                  top={6}
                  left="50%"
                  transform="translate(-50%, -50%)"
                  display={['block', null, 'none']}
                  onClick={handleClose}
                />
                {children}
              </ModalBody>
            </ModalContent>
          </Box>
        )}
      </Modal>
    </AnimatePresence>
  );
}

DrawerModal.defaultProps = {
  modalWidth: 500,
};

DrawerModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  modalWidth: PropTypes.number,
};
